(function () {
  'use strict';

  var FOCUSABLE = 'a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function lenis(method) {
    var l = window.lenisScroll && window.lenisScroll.lenis;
    if (l && typeof l[method] === 'function') l[method]();
  }

  function initRoot(root) {
    if (root.dataset.czfReady === 'true') return;
    root.dataset.czfReady = 'true';

    /* Flips the CSS defaults from open to closed. Set only once the script is
       running, so a visitor without JS reads every answer rather than none. */
    root.classList.add('czf--ready');

    var multiple = root.dataset.czfMultiple === 'true';
    var questions = Array.prototype.slice.call(root.querySelectorAll('.czf-q'));

    questions.forEach(function (q) {
      var head = q.querySelector('.czf-q__head');
      var wrap = q.querySelector('.czf-q__wrap');
      if (!head || !wrap) return;

      head.setAttribute('aria-expanded', q.classList.contains('is-open') ? 'true' : 'false');

      head.addEventListener('click', function () {
        var open = !q.classList.contains('is-open');

        if (open && !multiple) {
          // one at a time — close whatever is open in this group only
          var group = q.closest('.czf__group') || root;
          Array.prototype.forEach.call(group.querySelectorAll('.czf-q.is-open'), function (other) {
            if (other === q) return;
            other.classList.remove('is-open');
            var h = other.querySelector('.czf-q__head');
            if (h) h.setAttribute('aria-expanded', 'false');
          });
        }

        q.classList.toggle('is-open', open);
        head.setAttribute('aria-expanded', open ? 'true' : 'false');

        // an answer opening or closing moves every group below it
        scheduleSpy();
      });
    });

    /* ---------------- active category ----------------
       A plain scrollspy rather than an IntersectionObserver. IO hands the
       callback only the entries whose intersection changed, so when two
       groups cross the line in one frame the "winner" depends on the order
       the browser batched them — and these groups change height constantly as
       answers open. Walking the list is deterministic and cheap: a handful of
       getBoundingClientRect calls, once per animation frame that scrolls. */
    var anchors = Array.prototype.slice.call(root.querySelectorAll('[data-czf-anchor]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('.czf__group[id]'));
    var activeId = null;

    function markActive(id) {
      if (id === activeId) return;   // no DOM writes when nothing moved
      activeId = id;
      anchors.forEach(function (a) {
        var on = a.getAttribute('href') === '#' + id;
        a.classList.toggle('is-active', on);
        if (on) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    }

        function spy() {
      /* The editor swaps a section's markup wholesale, leaving these window
         listeners bound to a detached root. Without this they keep measuring
         elements that are no longer on the page. */
      if (!groups.length || !root.isConnected) return;


      // the reading line — a third down the viewport, where the eye sits
      var line = window.innerHeight * 0.3;
      var current = groups[0];

      for (var i = 0; i < groups.length; i++) {
        if (groups[i].getBoundingClientRect().top <= line) current = groups[i];
      }

      /* At the foot of the page nothing further can scroll, so a short final
         category would never reach the line and could never light up. */
      var doc = document.documentElement;
      if (window.innerHeight + window.scrollY >= doc.scrollHeight - 2) {
        current = groups[groups.length - 1];
      }

      markActive(current.id);
    }

    var ticking = false;
    function scheduleSpy() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        spy();
      });
    }

    if (anchors.length && groups.length) {
      window.addEventListener('scroll', scheduleSpy, { passive: true });
      window.addEventListener('resize', scheduleSpy);
      if ('ResizeObserver' in window) {
        // catches a group growing as an answer opens, and web fonts landing
        new ResizeObserver(scheduleSpy).observe(root);
      }

      // clicking an anchor should light it immediately, not a frame after the
      // scroll finally reaches the target
      anchors.forEach(function (a) {
        a.addEventListener('click', function () {
          var href = a.getAttribute('href') || '';
          if (href.charAt(0) === '#') markActive(href.slice(1));
        });
      });

      spy();
    }

    /* ---------------- mobile quick access ---------------- */
    var trigger = root.querySelector('[data-czf-quick]');
    var drawer = root.querySelector('[data-czf-drawer]');
    if (!trigger || !drawer) return;

    function openDrawer() {
      drawer.hidden = false;
      document.documentElement.classList.add('czf-locked');
      lenis('stop');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      });
      var close = drawer.querySelector('.czf__close');
      if (close) close.focus();
    }

    function closeDrawer(returnFocus) {
      if (drawer.hidden) return;
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('czf-locked');
      lenis('start');

      var fired = false;
      var done = function () {
        if (fired) return;
        fired = true;
        drawer.hidden = true;
        if (returnFocus) trigger.focus();
      };
      var panel = drawer.querySelector('.czf__panel');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!panel || reduce) { done(); return; }
      panel.addEventListener('transitionend', done, { once: true });
      setTimeout(done, 700);   // transitionend never fires if it was not painted
    }

    trigger.addEventListener('click', openDrawer);

    drawer.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-czf-close]')) { closeDrawer(true); return; }
      /* A link inside: let the browser do its own hash jump — scroll-margin
         handles the sticky bar, and hijacking it would fight Lenis. Only the
         sheet is dismissed, without pulling focus back to the trigger. */
      var link = e.target.closest && e.target.closest('a[href^="#"]');
      if (link) closeDrawer(false);
    });

    document.addEventListener('keydown', function (e) {
      if (drawer.hidden) return;
      if (e.key === 'Escape') { closeDrawer(true); return; }
      if (e.key !== 'Tab') return;

      var items = drawer.querySelectorAll(FOCUSABLE);
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-czard-faq]');
    Array.prototype.forEach.call(roots, initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
